import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import AdminPageLayout from '../../../layout/admin-page-layout';
import HubCard from './hub-card';
import { useAuth } from '../../../hooks/useAuth';
import { useCommunity } from '../../../hooks/useDistrict';
import { adminRoutesArray } from '../../../common/routes/admin';
import { buildNavItems } from '../../../common/routes/_';
const ContentHub = () => {
    const [auth] = useAuth();
    const { district } = useCommunity();
    const items = buildNavItems(adminRoutesArray, { group: 'content', kind: district.kind, hasPermission: auth.hasPermission });
    return (_jsx(AdminPageLayout, { children: _jsxs("div", { className: "container py-4", children: [_jsx("h4", { className: "fw-semibold mb-4", children: "Content" }), _jsx("div", { className: "row g-3", children: items.map(item => (_jsx("div", { className: "col-6 col-md-4 col-lg-3", children: _jsx(HubCard, { label: item.label, icon: item.icon, href: item.href, subtitle: item.description }) }, item.key))) })] }) }));
};
export default ContentHub;
